export default __webpack_public_path__ + "static/beefy-28a087db2aba27cd1b8aca246607794f.svg";